import { useState } from 'react'
import { api, ApiError } from '../lib/api.js'

// Login em 2 passos. O passo 1 responde igual para qualquer e-mail — nao ha
// como descobrir daqui quem tem acesso, e a tela nao finge que sabe.
export function Login({ aoEntrar }) {
  const [passo, setPasso] = useState('email')
  const [email, setEmail] = useState('')
  const [codigo, setCodigo] = useState('')
  const [erro, setErro] = useState(null)
  const [ocupado, setOcupado] = useState(false)

  async function pedirCodigo(evento) {
    evento.preventDefault()
    setErro(null)
    setOcupado(true)
    try {
      await api.post('/auth/otp/solicitar', { email: email.trim().toLowerCase() })
      setPasso('codigo')
    } catch (falha) {
      setErro(falha.message)
    } finally {
      setOcupado(false)
    }
  }

  async function validar(evento) {
    evento.preventDefault()
    setErro(null)
    setOcupado(true)
    try {
      await api.post('/auth/otp/validar', { email: email.trim().toLowerCase(), codigo: codigo.trim() })
      await aoEntrar()
    } catch (falha) {
      const restantes = falha instanceof ApiError ? falha.detalhes?.restantes : null
      setErro(restantes ? `${falha.message} (${restantes} tentativa(s) restante(s))` : falha.message)
      if (falha instanceof ApiError && falha.codigo === 'tentativas_esgotadas') {
        setPasso('email')
        setCodigo('')
      }
    } finally {
      setOcupado(false)
    }
  }

  return (
    <main className="pagina pagina--estreita">
      <header className="cabecalho-login">
        <h1>Portal IA</h1>
        <p className="subtitulo">Centro Médico Brasil</p>
      </header>

      {passo === 'email' ? (
        <form className="cartao" onSubmit={pedirCodigo}>
          <h2>Entrar</h2>
          <label className="campo">
            <span>E-mail</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
              required
            />
          </label>
          <button className="botao botao--primario" disabled={ocupado || !email.trim()}>
            {ocupado ? 'Enviando…' : 'Receber código'}
          </button>
        </form>
      ) : (
        <form className="cartao" onSubmit={validar}>
          <h2>Código de acesso</h2>
          <p className="ajuda">
            Se <strong>{email}</strong> tiver acesso, um código de 6 dígitos foi enviado. Ele expira em 10 minutos.
          </p>
          <label className="campo">
            <span>Código</span>
            <input
              className="campo-codigo"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value.replace(/\D/g, '').slice(0, 6))}
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              required
            />
          </label>
          <div className="linha-acoes">
            <button className="botao botao--primario" disabled={ocupado || codigo.length !== 6}>
              {ocupado ? 'Validando…' : 'Entrar'}
            </button>
            <button
              type="button"
              className="botao botao--discreto"
              onClick={() => {
                setPasso('email')
                setCodigo('')
                setErro(null)
              }}
            >
              Trocar e-mail
            </button>
          </div>
        </form>
      )}

      {erro && <p className="alerta alerta--falha">{erro}</p>}
    </main>
  )
}
